// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6cfoC","image":"Header_image__Bu9UW","name":"Header_name__2yv8o","info":"Header_info__JMm4x","infoRow":"Header_infoRow__29xbL"};